import { StateSchema } from 'app/config/storeConfig/types';
import { RentOptionFormDrawerSchema } from '../types';

export const getRentOptionFormState = (state: StateSchema): RentOptionFormDrawerSchema => state.rentOptionFormDrawer;
